<script>
  import formasPagamento from '~js/formas-pagamento';
  import tiposPagamento from '~js/tipos-pagamento';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        formasPagamento: formasPagamento,
        tiposPagamento: tiposPagamento,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      arrayRemove(arr, value) {
         return arr.filter(function(ele){
             return ele.id != value;
         });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualização Formas Pagamento
          if (!this.configuracao.solPgtoDeposito)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 0);

          if (!this.configuracao.solPgtoCheque)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 1);

          if (!this.configuracao.solPgtoOP)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 2);

          if (!this.configuracao.solPgtoBoleto)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 3);

          // Visualização Tipos Pagamento
          if (!this.configuracao.solPgtoValorBruto)
            this.tiposPagamento = this.arrayRemove(this.tiposPagamento, 0);

          if (!this.configuracao.solPgtoValorLiquido)
            this.tiposPagamento = this.arrayRemove(this.tiposPagamento, 1);
        }
      },
    },
    mounted() {
      //$('.datepicker input').attr('readonly', '');
      this.aplicaconfiguracaoweb();
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-3" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
        <div class="form-group required" :class="{'has-error': errors.has('dataPagamento')}">
          <label class="control-label">Data para pagamento</label>

          <datepicker
            v-model="solicitacao.dataPagamento"
            format="dd/MM/yyyy"
            placeholder="  /  /     "
            lang="pt-BR"
            data-vv-name="dataPagamento"
            data-vv-as="data para pagamento"
            v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>
          
          <p class="text-danger" v-show="errors.has('dataPagamento')">{{ errors.first('dataPagamento') }}</p>
        </div>
      </div>

      <div :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-4' : 'col-lg-6']">
        <div class="form-group required" :class="{'has-error': errors.has('formaPagamento')}">
          <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

          <select
              class="form-control"
              id="forma-pagamento"
              v-model="solicitacao.formaPagamento"
              data-vv-name="formaPagamento"
              data-vv-as="forma de pagamento"
              v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('formaPagamento')">{{ errors.first('formaPagamento') }}</p>
        </div>
      </div>

      <div :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-4' : 'col-lg-6']">
        <div class="form-group required" :class="{'has-error': errors.has('tipoPagamento')}">
          <label class="control-label" for="tipo-pagamento">Tipo</label>

          <select
              class="form-control"
              id="tipo-pagamento"
              v-model="solicitacao.tipoPagamento"
              data-vv-name="tipoPagamento"
              data-vv-as="tipo"
              v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="tipoPagamento.id" v-for="tipoPagamento in tiposPagamento">{{ tipoPagamento.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoPagamento')">{{ errors.first('tipoPagamento') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="nota-fiscal" class="control-label">Nota Fiscal</label>
  
          <input 
              type="text" 
              class="form-control"
              id="nota-fiscal"
              v-model="solicitacao.notaFiscal"
              maxlength="20">
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="form-group" :class="{'has-error': errors.has('dataEmissao')}">
          <label class="control-label">Data Emissão</label>

          <datepicker
              id="dataEmissao"
              v-mascara="'data-mask'"
              v-model="solicitacao.dataEmissao"
              format="dd/MM/yyyy"
              placeholder="  /  /     "
              lang="pt-BR"
              data-vv-name="dataEmissao"
              data-vv-as="data de emissão"
              v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataEmissao')">{{ errors.first('dataEmissao') }}</p>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="form-group" :class="{'has-error': errors.has('dataVencimento')}">
          <label class="control-label">Data Vencimento</label>

          <datepicker
              id="dataVencimento"
              v-mascara="'data-mask'"
              v-model="solicitacao.dataVencimento"
              format="dd/MM/yyyy"
              placeholder="  /  /     "
              lang="pt-BR"
              data-vv-name="dataVencimento"
              data-vv-as="data de vencimento"
              v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataVencimento')">{{ errors.first('dataVencimento') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="descricao">Atividade/descrição serviços</label>

          <textarea
              class="form-control"
              id="descricao"
              v-model="solicitacao.observacao"
              data-vv-name="observacao"
              data-vv-as="atividade/descrição serviços"
              v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/componentes/compartilhado/FormDadosPagamento.vue